import React from "react";
import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";

export const SentryFallback = ({ resetError }) => {
  return (
    <div
      data-testid="sentry-fallback"
      className="min-h-screen flex items-center justify-center bg-background px-6"
    >
      <div className="max-w-md w-full text-left space-y-5">
        <div className="flex items-center gap-3 text-destructive">
          <AlertTriangle className="h-6 w-6" />
          <h1 className="text-xl font-semibold tracking-tight">
            Something went wrong
          </h1>
        </div>
        <p className="text-sm text-muted-foreground">
          The team has been notified automatically. You can try to recover this
          page or reload the app.
        </p>
        <div className="flex gap-2">
          <Button
            data-testid="sentry-fallback-retry"
            onClick={resetError}
            variant="default"
          >
            Try again
          </Button>
          <Button
            data-testid="sentry-fallback-reload"
            onClick={() => window.location.reload()}
            variant="outline"
          >
            Reload page
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SentryFallback;
